import React from "react";
import { useNavigate } from "react-router-dom";
import { AppState, Auth0Provider } from "@auth0/auth0-react";

const Auth0ProviderWithHistory = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const navigate = useNavigate();
  const domain = process.env.REACT_APP_AUTH0_DOMAIN ?? "";
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID ?? "";
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  const onRedirectCallback = (appState?: AppState | undefined) => {
    const navigationRoute = appState?.returnTo ?? appState?.targetUrl ?? window.location.pathname;
    navigate(navigationRoute);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      // Do NOT fall back to the legacy hidden-iframe silent-auth flow. On iOS
      // Safari (ITP blocks the third-party cookie the iframe needs) that flow
      // throws `state_mismatch` ("Invalid state"), which useGetValidAccessToken
      // catches and turns into a logout — so iPhone users get bounced off
      // authenticated pages (Sentry FRONTEND-BP). Refresh tokens are a POST to
      // /oauth/token and aren't subject to ITP, so renewal keeps working; a
      // genuinely expired session still cleanly re-authenticates via login.
      useRefreshTokensFallback={false}
      cacheLocation={"localstorage"}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
